import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  scenePreviewContainer: {
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    ...shorthands.padding('0px', tokens.spacingHorizontalXXXL, '0px', tokens.spacingHorizontalXXXL),
  },
  scenePreviewImage: {
    maxWidth: '100%',
    maxHeight: '450px',
    ...shorthands.borderRadius('8px'),
  },
});
